import React, { useEffect, useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "rsuite";
import { toast } from "react-toastify";
import ErrorMessage from "../../../../../components/comman/ErrorMessage";
import moment from "moment";
import { Spinner } from "reactstrap";
import { apiUrl } from "../../../../../ApiHelper/ApiUrl";
import { callApi } from "../../../../../ApiHelper/ApiHelper";
import { errorTypes } from "../../../../../utility/InputValidation";
import { useSelector } from "react-redux";

export default function EmployeeBasicDetails({
  setFirstFormData,
  setPageStates,
  locationData,
  isUpdateFlow
}) {
  // console.log("locationDataInBasicTab======>", locationData);
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const userDetails = useSelector((state) => state.root.userDetails);
  const fileInputRef = useRef(null);
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    control,
    formState: { errors },
  } = useForm();

  const handleCapitalizeFirstLetter = (e, fieldName) => {
    const val = e.target.value;
    if (val.length > 0) {
      setValue(fieldName, val.charAt(0).toUpperCase() + val.slice(1), {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  useEffect(() => {
    if (locationData) {
      const name = locationData?.name?.split(" ");
      reset({
        firstName: name?.slice(0, -1)?.join(" "),
        lastName: name[name?.length - 1],
        bloodGroup: locationData?.bloodGroup,
        dob: locationData?.dob,
        email: locationData?.email,
        motherName: locationData?.userdetail?.motherName,
        fatherName: locationData?.userdetail?.fatherName,
        gender: locationData?.gender,
        isMarried: locationData?.isMarried?.toString(),
        skillType: locationData?.skillType,
        joiningDate:
          locationData?.joiningDate &&
          moment(locationData?.joiningDate).format("YYYY-MM-DD"),
        phone: locationData?.phone,
        profilePhoto: locationData?.profilePhoto,
        status: locationData?.status,
      });

      const validPhoto = locationData?.profilePhoto && locationData.profilePhoto !== "null" && locationData.profilePhoto !== "undefined" ? locationData.profilePhoto : null;
      setImage(validPhoto);
      setImageFile(validPhoto);
    }
  }, []);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 6 * 1024 * 1024) {
        toast.error("File size must be less than 6MB");
        event.target.value = "";
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
        setImageFile(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setImage(null);
    setImageFile(null);
    fileInputRef.current.value = null;
  };

  const onSubmit = (data) => {
    const firstFormSubmitData = {
      ...data,
      profilePhoto: imageFile,
      status: isUpdateFlow ? data?.status : "current",
    };

    if (locationData) {
      const formData = new FormData();
      formData.append(
        "name",
        (firstFormSubmitData?.firstName || "").trim() +
        " " +
        (firstFormSubmitData?.lastName || "").trim()
      );
      formData.append("email", firstFormSubmitData?.email);
      formData.append("phone", firstFormSubmitData?.phone);
      formData.append("dob", firstFormSubmitData?.dob);
      formData.append("gender", firstFormSubmitData?.gender);
      formData.append("bloodGroup", firstFormSubmitData?.bloodGroup);
      formData.append("profilePhoto", firstFormSubmitData?.profilePhoto);
      formData.append("fatherName", firstFormSubmitData?.fatherName);
      formData.append("motherName", firstFormSubmitData?.motherName);
      formData.append("isMarried", firstFormSubmitData?.isMarried === "true");
      formData.append("skillType", firstFormSubmitData?.skillType);
      formData.append("joiningDate", firstFormSubmitData?.joiningDate);
      formData.append("status", firstFormSubmitData?.status);
      formData.append("activeTab", "Basic Details");
      const options = {
        method: "POST",
        form_data: formData,
      };
      let API = apiUrl?.add_employee + `?userId=${locationData?.id}`;
      setIsLoading(true);
      callApi(API, options).then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          toast.success(response?.message);
          setPageStates((prev) => ({
            ...prev,
            activeTab: 2,
          }));
        } else {
          toast.error(response?.message);
        }
      });
    } else {
      setFirstFormData(firstFormSubmitData);
      setPageStates((prev) => ({
        ...prev,
        activeTab: 2,
      }));
    }
  };

  // console.log("image>>>>>>.",image);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="card shadow-sm border-0 rounded-3 mb-4">
      <div className="card-header bg-white border-bottom-0 pt-4 pb-2 px-4">
        <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
          Basic Details
        </h4>
        {/* <p className="text-muted small mb-0">Update the primary details and profile picture of the employee.</p> */}
      </div>
      <div className="card-body px-4 py-3">
        <div className="row">
          {/* Image upload section */}
          <div className="col-12 mb-4">
            <div className="d-flex align-items-center gap-4 p-3 bg-light rounded-3 border border-light">
              <div className="position-relative">
                <label
                  htmlFor="employeeImg"
                  className="d-block shadow-sm rounded-circle overflow-hidden bg-white mb-0"
                  style={{
                    cursor: "pointer",
                    width: "90px",
                    height: "90px",
                    border: "3px solid #fff",
                  }}
                >
                  {image ? (
                    <img
                      src={image}
                      alt="Preview"
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = import.meta.env.BASE_URL + "assets/img/employee.svg";
                      }}
                    />
                  ) : (
                    <div className="w-100 h-100 d-flex flex-column align-items-center justify-content-center text-muted bg-light border border-dashed rounded-circle">
                      <i className="fas fa-camera fs-5 mb-1"></i>
                      <span style={{ fontSize: "10px", fontWeight: "500" }}>Upload</span>
                    </div>
                  )}
                </label>
                {image && (
                  <button
                    className="btn btn-danger rounded-circle position-absolute d-flex align-items-center justify-content-center shadow-sm"
                    type="button"
                    onClick={removeImage}
                    style={{ top: "0", right: "0", width: "26px", height: "26px", padding: "0" }}
                  >
                    <i className="fas fa-times" style={{ fontSize: "12px" }} />
                  </button>
                )}
                <input
                  ref={fileInputRef}
                  className="form-control d-none"
                  type="file"
                  accept="image/*"
                  id="employeeImg"
                  onChange={handleImageUpload}
                />
              </div>
              <div>
                <h5 className="mb-1 text-dark fw-bold" style={{ fontSize: "16px" }}>Profile Photo</h5>
                <p className="text-muted small mb-0">Upload a professional headshot. Recommended format: JPG, PNG.</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="firstName" className="form-label">
                First name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="First name"
                id="firstName"
                maxLength={160}
                aria-describedby="emailHelp"
                {...register("firstName", {
                  ...errorTypes.required("First Name"),
                  ...errorTypes.name,
                  onChange: (e) => handleCapitalizeFirstLetter(e, "firstName")
                })}
              />
              <ErrorMessage message={errors?.firstName?.message} />
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="LastName" className="form-label">
                Last name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Last name"
                id="LastName"
                aria-describedby="emailHelp"
                maxLength={160}
                {...register("lastName", {
                  ...errorTypes.required("Last Name"),
                  ...errorTypes.name,
                  onChange: (e) => handleCapitalizeFirstLetter(e, "lastName")
                })}
              />
              <ErrorMessage message={errors?.lastName?.message} />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="Role" className="form-label">
                Gender <span className="text-danger">*</span>
              </label>
              <select
                className="form-select form-control"
                aria-label="Default select example"
                {...register("gender", {
                  ...errorTypes.required("Gender"),
                })}
              >
                <option value="" className="d-none">
                  Select Gender
                </option>
                <option value={0}>Male</option>
                <option value={1}>Female</option>
              </select>
            </div>
            <ErrorMessage message={errors?.gender?.message} />
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="email" className="form-label">
                Email <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter Email"
                id="email"
                {...register("email", {
                  ...errorTypes.required("Email"),
                  ...errorTypes.email,
                })}
              />
              <ErrorMessage message={errors?.email?.message} />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="MobileNO" className="form-label">
                Mobile No. <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Mobile No."
                id="MobileNO"
                maxLength={10}
                {...register("phone", {
                  ...errorTypes.required("Phone"),
                  ...errorTypes.phone,
                })}
                onChange={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Allow only digits (0-9)
                }}
              />
              <ErrorMessage message={errors?.phone?.message} />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="Datebirth" className="form-label">
                Date of Birth <span className="text-danger">*</span>
              </label>
              <Controller
                name="dob"
                control={control}
                rules={{
                  ...errorTypes.required("Date of Birth"),
                  validate: (value) => {
                    if (!value) return "Date of Birth is required";

                    // Check if DOB equals joining date
                    const joiningDate = watch("joiningDate");
                    if (joiningDate && value === joiningDate) {
                      return "Date of Birth cannot be the same as Joining Date";
                    }

                    const birthDate = new Date(value);
                    const today = new Date();
                    let age = today.getFullYear() - birthDate.getFullYear();
                    const monthDiff = today.getMonth() - birthDate.getMonth();

                    // Adjust age if birthday hasn't occurred yet this year
                    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                      age--;
                    }

                    if (age < 18) {
                      return "Employee must be at least 18 years old";
                    }

                    return true;
                  },
                }}
                render={({ field }) => (
                  <DatePicker size="sm"
                    {...field}
                    id="Datebirth"
                    format="dd/MM/yyyy"
                    oneTap
                    placeholder="dd/mm/yyyy"
                    style={{ width: "100%" }}
                    value={field.value ? new Date(field.value) : null}
                    onChange={(date) => {
                      field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                    }}
                    shouldDisableDate={(date) => date > new Date()}
                    cleanable={false}
                  />
                )}
              />
              <ErrorMessage message={errors?.dob?.message} />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="FatherName" className="form-label">
                Father name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Father name"
                id="FatherName"
                aria-describedby="emailHelp"
                maxLength={160}
                {...register("fatherName", {
                  ...errorTypes.required("Father Name"),
                  ...errorTypes.name,
                  onChange: (e) => handleCapitalizeFirstLetter(e, "fatherName")
                })}
              />
              <ErrorMessage message={errors?.fatherName?.message} />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="MotherName" className="form-label">
                Mother name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Mother name"
                id="MotherName"
                aria-describedby="emailHelp"
                maxLength={160}
                {...register("motherName", {
                  ...errorTypes.required("Mother Name"),
                  ...errorTypes.name,
                  onChange: (e) => handleCapitalizeFirstLetter(e, "motherName")
                })}
              />
              <ErrorMessage message={errors?.motherName?.message} />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="joinDate" className="form-label">
                Joining Date
                <span className="text-danger">*</span>
              </label>
              <Controller
                name="joiningDate"
                control={control}
                rules={{
                  ...errorTypes.required("Joining Date"),
                  validate: (value) => {
                    if (!value) return "Joining Date is required";

                    // Check if joining date equals DOB
                    const dob = watch("dob");
                    if (dob && value === dob) {
                      return "Joining Date cannot be the same as Date of Birth";
                    }

                    return true;
                  },
                }}
                render={({ field }) => (
                  <DatePicker size="sm"
                    {...field}
                    id="joinDate"
                    format="dd/MM/yyyy"
                    oneTap
                    placeholder="dd/mm/yyyy"
                    style={{ width: "100%" }}
                    value={field.value ? new Date(field.value) : null}
                    onChange={(date) => {
                      field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                    }}
                    cleanable={false}
                  />
                )}
              />
              <ErrorMessage message={errors?.joiningDate?.message} />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="Role" className="form-label">
                Blood Group <span className="text-danger">*</span>
              </label>
              <select
                className="form-select form-control"
                aria-label="Default select example"
                {...register("bloodGroup", {
                  ...errorTypes.required("Blood Group"),
                })}
              >
                <option value="" className="d-none">
                  Select Blood Group
                </option>
                <option value={"A+"}>A+</option>
                <option value={"A-"}>A-</option>
                <option value={"B+"}>B+</option>
                <option value={"B-"}>B-</option>
                <option value={"O+"}>O+</option>
                <option value={"O-"}>O-</option>
                <option value={"AB+"}>AB+</option>
                <option value={"AB-"}>AB-</option>
              </select>
              <ErrorMessage message={errors?.bloodGroup?.message} />
            </div>
          </div>
          {isUpdateFlow && <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="Role" className="form-label">
                Status <span className="text-danger">*</span>
              </label>
              <select
                className="form-select form-control"
                aria-label="Default select example"
                disabled={
                  (userDetails?.department?.name === "HRM" &&
                    locationData?.department?.name === "HRM") ||
                  (userDetails?.department?.name === "Solar / Wind" &&
                    userDetails?.designation?.name === "Plant Head") ||
                  userDetails?.id === locationData?.id
                }
                {...register("status", {
                  ...errorTypes.required("Status"),
                })}
              >
                <option value="" className="d-none">
                  Select Status
                </option>
                <option value={"current"}>Current</option>
                <option value={"exEmployee"}>Ex-Employee</option>
              </select>
              <ErrorMessage message={errors?.status?.message} />
            </div>
          </div>}
          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="Role" className="form-label">
                Marital Status <span className="text-danger">*</span>
              </label>
              <select
                className="form-select form-control"
                aria-label="Default select example"
                {...register("isMarried", {
                  ...errorTypes.required("Marital Status"),
                })}
              >
                <option value="" className="d-none">
                  Select Marital Status
                </option>
                <option value="true">Married</option>
                <option value="false">Unmarried</option>
              </select>

              <ErrorMessage message={errors?.isMarried?.message} />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="Role" className="form-label">
                Skill Type <span className="text-danger">*</span>
              </label>
              <select
                className="form-select form-control"
                aria-label="Default select example"
                disabled={
                  (userDetails?.department?.name === "HRM" &&
                    locationData?.department?.name === "HRM") ||
                  (userDetails?.department?.name === "Solar / Wind" &&
                    userDetails?.designation?.name === "Plant Head") ||
                  userDetails?.id === locationData?.id
                }
                {...register("skillType", {
                  ...errorTypes.required("skill type"),
                })}
              >
                <option value="" className="d-none">
                  Select Skill Type
                </option>
                <option value="Unskilled">Unskilled</option>
                <option value="Semi- Skilled">Semi- Skilled</option>
                <option value="Skilled">Skilled</option>
                <option value="Highly Skilled">Highly Skilled</option>
              </select>
              <ErrorMessage message={errors?.skillType?.message} />
            </div>
          </div>
        </div>
      </div>
      <div className="card-footer bg-white border-top py-3 px-4 d-flex align-items-center justify-content-end rounded-bottom-3">
        <button className="btn btn-primary px-4 fw-semibold shadow-sm d-flex align-items-center gap-2" type="submit" disabled={isLoading}>
          {isLoading && <Spinner size="sm" />}
          {locationData ? (isLoading ? "Updating..." : "Update and Continue") : "Save and Continue"}
        </button>
      </div>
    </form>
  );
}
